// Domain mapping / staging
interface Environment {
  name: string
  pattern: RegExp
  morningstarBaseUrl?: string
  samlBaseUrl?: string
}

interface EnvironmentUrls {
  morningstarBaseUrl: string | undefined
  samlBaseUrl: string | undefined
}

const devMorningstarBaseUrl = 'https://awrduat.morningstar.com'
const devSamlBaseUrl = 'https://mni.qa.ameriprise.com'
const prodMorningstarBaseUrl = 'https://awrd.morningstar.com'
const prodSamlBaseUrl = 'https://mni.ameriprise.com'

const environments: Environment[] = [
  {
    name: 'dev',
    pattern: /^(http|https):?\/\/www\d*\.qa\.stage\.ameriprise.com\//,
    morningstarBaseUrl: devMorningstarBaseUrl,
    samlBaseUrl: devSamlBaseUrl
  },
  {
    name: 'qa',
    pattern: /^(http|https):?\/\/www\d*\.qa\.ameriprise.com\//,
    morningstarBaseUrl: devMorningstarBaseUrl,
    samlBaseUrl: devSamlBaseUrl
  },
  {
    name: 'prod',
    pattern: /^(http|https):?\/\/www\.ameriprise.com\//,
    morningstarBaseUrl: prodMorningstarBaseUrl,
    samlBaseUrl: prodSamlBaseUrl
  },
  {
    name: 'localhost',
    pattern: /^(http|https):?\/\/localhost/
  }
]

/**
 * getEnvironment
 */
export function getEnvironment(url = ''): string {
  const resolvedUrl = url || window.location.toString()

  const env = environments.find(e => e.pattern.test(resolvedUrl))

  return (env && env.name) || 'prod'
}

/**
 * getEnvironmentUrls
 */
export function getEnvironmentUrls(name: string): EnvironmentUrls {
  const env =
    environments.find(e => e.name === name) ?? ({} as Partial<Environment>)

  const { morningstarBaseUrl, samlBaseUrl } = env
  return { morningstarBaseUrl, samlBaseUrl }
}
